import React, { Fragment } from 'react'
import Link from 'redux-first-router-link'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { FORGOT_PASSWORD_PAGE, FORGOT_SUBDOMAIN_PAGE } from 'constants/pages'
import { Form } from 'util/ui'
import { propFunc } from 'util/functions'
import { slugify } from 'util/url'
import ValidatedField from 'shared/components/ui/ValidatedField'
import FormError from 'shared/components/ui/Form/Error'
import ParsedInput from 'shared/components/ui/ParsedInput'
import { TextDivider } from 'shared/ui'
import OAuthButton from 'components/OAuthButton'

import { styles } from './styles'

const subdomainLabelOptions = { basic: true, content: '.groovehq.com' }

class LoginForm extends React.PureComponent {
  manualSubdomain = false

  handleChange = (name, _, { value, checked }) => {
    const { onChange, onValidate } = this.props
    onChange(name, checked === undefined ? value : checked)
    onValidate(name, checked === undefined ? value : checked)
  }

  handleSubdomainChange = (_, { value }) => {
    const { onChange, onValidate } = this.props
    this.manualSubdomain = true
    onChange('subdomainInput', value)
    onValidate('subdomainInput', value)
  }

  render() {
    const {
      formFields,
      formFieldsErrors,
      submitForm,
      canSave,
      saving,
      loginError,
      isAccountSubdomain,
      doGoogleLogin,
      doOfficeLogin,
    } = this.props
    return (
      <Form size="large" data-test-id="login">
        {!isAccountSubdomain && (
          <Form.Field>
            <ValidatedField
              placeholder="groove-url"
              label={subdomainLabelOptions}
              labelPosition="right"
              value={formFields.subdomainInput}
              errorMessage={formFieldsErrors.subdomainInput}
              onChange={this.handleSubdomainChange}
              validatedFieldComponent={ParsedInput}
              parse={slugify}
              autoComplete="organization"
              name="subdomain"
            />
          </Form.Field>
        )}
        <Form.Field>
          <ValidatedField
            placeholder="Email Address"
            type="email"
            value={formFields.emailInput}
            errorMessage={formFieldsErrors.emailInput}
            onChange={propFunc(this.handleChange, 'emailInput')}
            autoComplete="email"
            name="email"
          />
        </Form.Field>
        <Form.Field>
          <ValidatedField
            placeholder="Password"
            type="password"
            value={formFields.passwordInput}
            errorMessage={formFieldsErrors.passwordInput}
            onChange={propFunc(this.handleChange, 'passwordInput')}
            autoComplete="current-password"
            name="password"
          />
        </Form.Field>
        {loginError && <FormError error={loginError} />}
        <Button
          id="login-email"
          className="action"
          name="loginButton"
          type="info"
          size="xBig"
          css={styles.btnLogin}
          onClick={submitForm}
          disabled={!canSave}
        >
          {!saving ? 'Sign in' : 'Signing in...'}
        </Button>
        <TextDivider>Or</TextDivider>
        <OAuthButton
          id="login-google"
          key="google"
          onClick={doGoogleLogin}
          iconName="googleLogo"
          text="Sign in with Google"
          savingText="Signing in…"
          saving={saving}
          className="lean-round"
        />
        <OAuthButton
          id="login-office-365"
          key="office"
          onClick={doOfficeLogin}
          iconName="officeLogo"
          text="Sign in with Office 365"
          savingText="Signing in…"
          saving={saving}
          className="lean-round"
        />
        <hr />
        <Form.Field className="links">
          <Link to={{ type: FORGOT_PASSWORD_PAGE }}>Forgot password</Link>
          {!isAccountSubdomain && (
            <Fragment>
              {' or '}
              <Link to={{ type: FORGOT_SUBDOMAIN_PAGE }}>subdomain</Link>
            </Fragment>
          )}
        </Form.Field>
      </Form>
    )
  }
}

export default LoginForm
